import {
    DataHygieneStatus,
    StatusProps,
} from 'assets/js/pages/contacts/data-hygiene/DataHygieneStatus';
import { PhoneNumberDeliverabilityStatus } from 'types/domain';

interface PhoneNumberStatusProps {
    status: PhoneNumberDeliverabilityStatus;
}

const PhoneNumberStatus = ({ status }: PhoneNumberStatusProps) => {
    const statusMatch: StatusProps = getPhoneNumberStatusProps(status);

    if (!statusMatch) {
        return null;
    }

    return <DataHygieneStatus status={statusMatch} />;
};

const HELP_TEXT = {
    DELIVERABLE: `This phone number is deliverable and will reach the intended recipient.`,
    UNDELIVERABLE: `This number is either not deliverable or it is a disposable number. It may not be deliverable because it includes wrong information or the phone number does not exist.`,
    BOUNCED: `A bounced phone number is due to a text delivery attempt being blocked, sent to an incorrect number, or landline.`,
    LANDLINE: `Landline numbers as primary phone numbers are flagged so that a mobile number can be added for text message communications.`,
};

const getPhoneNumberStatusProps = (status: PhoneNumberDeliverabilityStatus) => {
    switch (status) {
        case 'deliverable':
            return {
                displayText: 'Deliverable',
                dotColor: 'bg-green-500',
                tooltipText: HELP_TEXT.DELIVERABLE,
            };
        case 'undeliverable': /* falls through */
        case 'invalid': /* falls through */
        case 'disposable':
            return {
                displayText: 'Invalid phone number',
                dotColor: 'bg-red-500',
                tooltipText: HELP_TEXT.UNDELIVERABLE,
            };
        case 'bounced':
            return {
                displayText: 'Bounced text',
                dotColor: 'bg-orange-500',
                tooltipText: HELP_TEXT.BOUNCED,
            };
        case 'landline':
            return {
                displayText: 'Landline number',
                dotColor: 'bg-brand-violet-primary',
                tooltipText: HELP_TEXT.LANDLINE,
            };
    }
};

export { PhoneNumberStatus };
